// @flow

import React from 'react';
import { Route, Router } from 'react-router-dom';
// import { ConnectedRouter } from 'connected-react-router/immutable';
import { Provider } from 'react-redux';
import history from 'client/utils/history';
import store from 'client/redux/store';
import 'client/app/assets/js/webOSTV';
import SentryWrapper from 'client/containers/SentryWrapper';
import KeyControl from './KeyControl';

export default () => (
  <Provider store={store}>
    <Router history={history}>
      <SentryWrapper>
        <Route component={KeyControl} />
      </SentryWrapper>
    </Router>
  </Provider>
);
